module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"email":"Email","role":"Role","firstName":"First name","lastName":"Last name","country":"Country","password":"Password","passwordCurrent":"Current password","passwordNew":"New password","again":"(again)","verifySuccess":"User verified"}}')
  delete Component.options._Ctor
}
